import { render, staticRenderFns } from "./AnnouncementList.vue?vue&type=template&id=66aee902&scoped=true&"
import script from "./AnnouncementList.vue?vue&type=script&lang=ts&"
export * from "./AnnouncementList.vue?vue&type=script&lang=ts&"
import style0 from "./AnnouncementList.vue?vue&type=style&index=0&id=66aee902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aee902",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VCol,VContainer,VItemGroup,VRow,VSpacer,VToolbar,VToolbarTitle})
